<div class="w-full lg:max-w-full lg:flex login-page">
  <div
    class="h-48 lg:h-auto flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden image-login"
    style="background-image: url('assets/img/img_login.png'); width: 60%"
    alt="image"
  ></div>
  <div
    class="border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-login"
  >
    <div class="flex justify-between mb-10">
      <div
        class="logo-icon"
        style="background-image: url('assets/img/logo_unchk.png')"
      ></div>
      <div
        class="logo-icon"
        style="background-image: url('assets/img/logo_master_card.png')"
      ></div>
    </div>

    <div class="">
      <app-card-form [title]="titleCard">
        <button
          type="button"
          class="text-gray-900 bg-white hover:bg-gray-100 border border-gray-400 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 inline-flex justify-center items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
        >
          Nouveau de mot de passe
        </button>
        <div class="">
          <div class="inline-flex items-center justify-center w-full">
            <hr class="w-full h-px bg-gray-300 border-0 dark:bg-gray-700" />
            <span
              class="absolute px-3 font-medium text-gray-900 bg-white dark:text-white dark:bg-gray-900"
              >Doit contenir au moins 8 caractères.</span
            >
          </div>
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <form [formGroup]="userForm">
            <div>
              <label
                for="passwordFirst"
                class="block text-sm font-medium leading-6 text-gray-500"
                >Mot de passe*</label
              >
              <div class="mt-2">
                <input
                  id="passwordFirst"
                  formControlName="passwordFirst"
                  type="password"
                  name="passwordFirst"
                  [(ngModel)]="passwordFirst"
                  (input)="validatePasswords()"
                  autocomplete="current-password"
                  placeholder="Saisir le mot de passe"
                  required
                  class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div style="margin-top: 18px">
              <div class="flex items-center justify-between">
                <label
                  for="passwordSecond"
                  class="block text-sm font-medium leading-6 text-gray-500"
                  placeholder="nom@force.sn"
                  >Confirmation*
                </label>
              </div>
              <div class="mt-2">
                <input
                  id="passwordSecond"
                  formControlName="passwordSecond"
                  type="password"
                  name="passwordSecond"
                  [(ngModel)]="passwordSecond"
                  (input)="validatePasswords()"
                  autocomplete="current-password"
                  placeholder="Confirmer le mot de passe"
                  required
                  class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <br /><br />

            <div>
              <button
                (click)="onSubmit()"
                [disabled]="!passwordsMatch()"
                type="submit"
                class="flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 btn-login"
              >
                Réinitialiser mon mot de passe
              </button>
            </div>
            <div *ngIf="passwordError" class="error">{{ passwordError }}</div>
          </form>
        </div>
      </app-card-form>
    </div>

    <div class="flex justify-center mt-8">
      <div
        class="logo-icon"
        style="background-image: url('assets/img/logo_force_n.png')"
      ></div>
    </div>
  </div>
</div>
